import type { AppState } from '@/redux/store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectCurrentQuestionCanGoNext } from './slider.selectors';
import SliderSlice from './slider.slice';
import type { SliderTypeContext } from '@/components/slider-type/context';

interface GoToNextStepPayload {
  key: string;
  onNext: SliderTypeContext['onNext'];
}

interface GoToNextStepThunkConfig {
  state: AppState;
}

export const goToNextStep = createAsyncThunk<void, GoToNextStepPayload, GoToNextStepThunkConfig>(
  'slider/goToNextStep',
  (payload, thunkAPI) => {
    thunkAPI.dispatch(SliderSlice.actions.prepareSliderForNextStep(payload.key));
    const canGoNext = selectCurrentQuestionCanGoNext(payload.key)(thunkAPI.getState());
    const value = SliderSlice.selectors.answersDefault(thunkAPI.getState())[payload.key];
    if (canGoNext) {
      payload.onNext('action-button', value);
    }
    thunkAPI.dispatch(SliderSlice.actions.setValidationDirtyByKey(payload.key));
  },
);
